import type { DistributedOmit } from 'type-fest';
import type {
  FrameIncomingMessage,
  FrameOutgoingMessage,
} from './shared/frameMessage';

const sendMessageToSlabFrame = (
  message: DistributedOmit<FrameIncomingMessage, 'slab.id'>,
) => {
  window.parent.postMessage(
    {
      'slab.id': window.name,
      ...message,
    },
    '*',
  );
};

export const listenerFrameMessage = (
  handleMessage: (message: FrameOutgoingMessage) => void,
) => {
  const listener = (event: MessageEvent) => {
    if (
      event.data &&
      typeof event.data === 'object' &&
      'slab.type' in event.data
    ) {
      handleMessage(event.data as FrameOutgoingMessage);
    }
  };

  window.addEventListener('message', listener);

  return () => {
    window.removeEventListener('message', listener);
  };
};

export default sendMessageToSlabFrame;
